
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaiertigacabservice() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Ertiga Cab Service',
        heading: 'Meghana Cab : Pune to Mumbai Ertiga Cab Service',
        headingDescription: 'Meghana Cab offers Pune to Mumbai Ertiga Cab Service, ideal for families and small groups looking for a spacious, comfortable, and affordable travel option. Our Ertiga cabs come equipped with air conditioning, ample legroom, and generous luggage space, making long-distance travel smooth and enjoyable. Whether you are heading to Mumbai for an airport drop, a business meeting, or a leisure trip, our experienced drivers ensure a safe and timely journey. Enjoy door-to-door service, transparent pricing, and 24/7 customer support. Book your Pune to Mumbai Ertiga Cab with Meghana Cab and travel in comfort, style, and confidence.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

  "services": [
    {
      "name": "Ertiga Cab Pune to Mumbai",
      "description": "Book a reliable and spacious Ertiga cab from Pune to Mumbai for a smooth intercity journey. With comfortable seating for up to 6 passengers, ample boot space, and modern interiors, it's a popular choice for both business and leisure travelers looking for a hassle-free ride."
    },
    {
      "name": "Hire Ertiga for Pune to Mumbai Trip",
      "description": "Planning a trip to Mumbai from Pune? Hire an Ertiga for a comfortable and safe travel experience. Ideal for small groups and families, this MPV comes with professional drivers, AC, and sufficient luggage space, ensuring a seamless highway drive."
    },
    {
      "name": "6-Seater Cab Pune to Mumbai",
      "description": "Need extra seats for your group travel? Our 6-seater Ertiga cabs from Pune to Mumbai offer the perfect balance of comfort, space, and value. Suitable for group outings, airport transfers, or family trips with generous seating and smooth suspension."
    },
    {
      "name": "AC Ertiga Taxi Pune to Mumbai",
      "description": "Travel in a cool and cozy environment with our air-conditioned Ertiga taxi service from Pune to Mumbai. Enjoy efficient climate control, reclining seats, and a well-maintained vehicle throughout the journey, making long distances feel effortless."
    },
    {
      "name": "SUV Taxi Pune to Mumbai Ertiga",
      "description": "Our Ertiga falls in the SUV/MPV category, providing excellent comfort and ride quality on the Pune–Mumbai route. This SUV cab service is perfect for highway travel, offering superior handling, visibility, and road grip for a safe and steady trip."
    },
    {
      "name": "Family Ertiga Cab Pune to Mumbai",
      "description": "Heading to Mumbai with your loved ones? Our family Ertiga cab is tailored for comfortable and safe travel. It includes ample seating, adjustable air vents, rear AC, and trained drivers who prioritize your family’s needs throughout the ride."
    },
    {
      "name": "Budget Ertiga Cab Hire Pune to Mumbai",
      "description": "Looking for a budget-friendly SUV for your journey? Our Ertiga cabs offer a cost-effective solution with top-tier comfort and service quality. Perfect for group travel without straining your budget, this service includes competitive pricing and transparent fares."
    },
    {
      "name": "Online Booking Ertiga Pune to Mumbai",
      "description": "Book your Ertiga cab from Pune to Mumbai online in just a few taps. Our platform offers real-time availability, upfront fare estimates, instant confirmation, and full driver and vehicle details—making the process smooth and secure."
    },
    {
      "name": "Comfortable Ertiga for Pune to Mumbai Travel",
      "description": "Experience a comfortable long-distance ride in our premium Ertiga cabs. With spacious interiors, adjustable seats, armrests, and clean upholstery, this vehicle is designed for highway journeys and ensures a relaxed experience for all passengers."
    },
    {
      "name": "Group Cab Pune to Mumbai Ertiga",
      "description": "Traveling as a group? Our Ertiga group cab service accommodates up to 6 passengers, making it perfect for friend circles, office colleagues, or family units. Enjoy door-to-door pickup, reliable service, and a comfortable shared ride to Mumbai."
    },
    {
      "name": "Chauffeur Driven Ertiga Cab Pune to Mumbai",
      "description": "Enjoy the convenience of a chauffeur-driven Ertiga for your Pune to Mumbai trip. Our drivers are professional, courteous, and trained for long-distance highway travel. Sit back, relax, and enjoy a premium riding experience from door to door."
    },
    {
      "name": "One Way Ertiga Cab Pune to Mumbai",
      "description": "Save on travel costs with our one-way Ertiga taxi service. Whether you're heading to Mumbai airport or relocating, our one-way cab from Pune to Mumbai offers flexible timings, no return fare, and door-to-door service tailored to your schedule."
    },
    {
      "name": "Round Trip Ertiga Taxi Pune to Mumbai",
      "description": "Book a round trip Ertiga cab for your Mumbai visit. Ideal for day trips, business visits, or weekend plans, this service provides the same cab for your return journey, giving you control over your time, comfort, and driver availability."
    },
    {
      "name": "Ertiga Long Drive Pune to Mumbai",
      "description": "Embark on a smooth and scenic long drive from Pune to Mumbai in our well-maintained Ertiga cabs. This MPV is designed for comfort on highways, making long rides enjoyable for all passengers with soft suspension and superior road handling."
    },
    {
      "name": "Affordable SUV Pune to Mumbai Cab",
      "description": "Looking for an affordable SUV option? Our Ertiga cabs are priced competitively while offering top-notch service. Perfect for travelers who need both affordability and space, this service ensures a balanced and satisfying travel experience."
    }
  ],
  "tableData": [
    ["Ertiga Cab Pune to Mumbai", "Hire Ertiga for Pune to Mumbai Trip"],
    ["6-Seater Cab Pune to Mumbai", "AC Ertiga Taxi Pune to Mumbai"],
    ["SUV Taxi Pune to Mumbai Ertiga", "Family Ertiga Cab Pune to Mumbai"],
    ["Budget Ertiga Cab Hire Pune to Mumbai", "Online Booking Ertiga Pune to Mumbai"],
    ["Comfortable Ertiga for Pune to Mumbai Travel", "Group Cab Pune to Mumbai Ertiga"],
    ["Chauffeur Driven Ertiga Cab Pune to Mumbai", "One Way Ertiga Cab Pune to Mumbai"],
    ["Round Trip Ertiga Taxi Pune to Mumbai", "Ertiga Long Drive Pune to Mumbai"],
    ["Affordable SUV Pune to Mumbai Cab", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Spacious and Comfortable Ertiga for Pune to Mumbai Travel",
        "WhyChoosedescription": "Our Ertiga cab service from Pune to Mumbai is ideal for families, small groups, and travelers who value space and comfort. The 6-7 seater configuration offers ample legroom and luggage capacity, making it perfect for long-distance journeys with multiple passengers or extra baggage."
    },
    {
        "WhyChooseheading": "Clean, Well-Maintained, and Air-Conditioned Vehicles",
        "WhyChoosedescription": "Each Ertiga in our fleet is kept in top condition with regular servicing, thorough cleaning, and pre-ride sanitization. Equipped with dual air-conditioning and reclining seats, our cabs ensure a pleasant ride in all weather conditions, even during long hours on the road."
    },
    {
        "WhyChooseheading": "Professional, Courteous, and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are trained, background-verified, and highly experienced in intercity travel. They know the Pune–Mumbai route well, follow safe driving practices, and provide respectful, friendly service throughout the journey. You can relax and enjoy the ride while we handle the road."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Group Travel",
        "WhyChoosedescription": "Traveling with a group? The Ertiga is a cost-effective choice. Our rates include all essential charges—fuel, tolls, taxes, and driver allowance—so there are no surprise fees. Enjoy a spacious, premium ride without stretching your budget."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Business Trips, and Family Travel",
        "WhyChoosedescription": "Whether you’re heading to Mumbai Airport with luggage, planning a business trip with colleagues, or taking your family for a city visit, our Ertiga cab offers the perfect balance of space, comfort, and convenience for every occasion."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop-off for Complete Convenience",
        "WhyChoosedescription": "Skip the hassle of finding transport to a pickup point. We pick you up directly from your home or office in Pune and drop you exactly where you need to go in Mumbai—be it a hotel, airport, or any residential area. End-to-end comfort, guaranteed."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Schedule",
        "WhyChoosedescription": "Choose from one-way trips, round trips, or even multi-stop bookings. With our flexible plans, you can customize your journey as needed—perfect for both business and personal travel. Let us know your itinerary, and we’ll take care of the rest."
    },
    {
        "WhyChooseheading": "24/7 Support and Hassle-Free Online Booking",
        "WhyChoosedescription": "Book your Ertiga cab anytime with our easy-to-use online platform or speak with our friendly support team. We're available 24/7 to help with bookings, changes, or special requests—ensuring your journey is smooth from the moment you schedule your ride."
    }
]




























    }

const faqData = [
    {
        question: "How can I book an Ertiga cab from Pune to Mumbai?",
        answer: "You can book an Ertiga cab by calling Meghana Cab at +91 9075462128 or through our website for instant confirmation."
    },
    {
        question: "Is the Ertiga suitable for group or family travel from Pune to Mumbai?",
        answer: "Yes, the Ertiga is a spacious 6-7 seater, ideal for families or small groups traveling together."
    },
    {
        question: "How long does the Pune to Mumbai journey take in an Ertiga?",
        answer: "The journey typically takes around 3 to 4 hours, depending on traffic and road conditions."
    },
    {
        question: "Is the Pune to Mumbai Ertiga cab service available 24/7?",
        answer: "Yes, Meghana Cab provides 24/7 Ertiga cab service for your convenience, including late-night and early-morning travel."
    },
    {
        question: "What is included in the fare for an Ertiga cab?",
        answer: "The fare includes fuel, tolls, and driver charges. Parking fees or extra waiting time may incur additional costs."
    },
    {
        question: "Can I book an Ertiga for a one-way trip from Pune to Mumbai?",
        answer: "Yes, one-way and round-trip bookings are available for Ertiga cabs."
    },
    {
        question: "Is the Ertiga cab comfortable for long-distance travel?",
        answer: "Absolutely. Ertiga offers ample legroom, AC, and comfortable seating for a smooth journey."
    },
    {
        question: "Can I request short breaks or meal stops during the ride?",
        answer: "Yes, you can request stops for meals or rest. Just inform the driver or mention it while booking."
    },
    {
        question: "How do I pay for the Ertiga cab booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "Are Meghana Cab drivers experienced with this route?",
        answer: "Yes, our drivers are highly experienced and well-acquainted with the Pune to Mumbai route."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ashok Bhosale',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked an Ertiga from Pune to Mumbai. The car was clean, spacious, and perfect for our family trip. Highly recommended!”',
    },
    {
        name: 'Ms. Tanvi Apte',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth ride and courteous driver. Meghana Cab’s Ertiga service made our Pune to Mumbai journey very comfortable.”',
    },
];


























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Ertiga Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-ertiga-cab.jpg",
  "description": "Hire a comfortable and spacious Ertiga cab from Pune to Mumbai with Meghana Cabs. Ideal for families and groups, with AC, chauffeur-driven service, available for one-way and round trips. Book online 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-ertiga-cab-service"
  }
};






    return (
        <div>


<Helmet>
  <title>Pune to Mumbai Ertiga Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book an AC Ertiga cab for Pune to Mumbai travel with Meghana Cabs. Spacious 6-seater, comfortable and chauffeur-driven. Available for one-way and round trips with easy online booking." 
  />
  <meta 
    name="keywords" 
    content="Ertiga Cab Pune to Mumbai, Hire Ertiga for Pune to Mumbai Trip, 6-Seater Cab Pune to Mumbai, AC Ertiga Taxi Pune to Mumbai, SUV Taxi Pune to Mumbai Ertiga, Family Ertiga Cab Pune to Mumbai, Budget Ertiga Cab Hire Pune to Mumbai, Online Booking Ertiga Pune to Mumbai, Comfortable Ertiga for Pune to Mumbai Travel, Group Cab Pune to Mumbai Ertiga, Chauffeur Driven Ertiga Cab Pune to Mumbai, One Way Ertiga Cab Pune to Mumbai, Round Trip Ertiga Taxi Pune to Mumbai, Ertiga Long Drive Pune to Mumbai, Affordable SUV Pune to Mumbai Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiertigacabservice;